import React from 'react';
import {Link} from 'react-router-dom';
import './nav-css.css';

const Nav = () => (
    <div className="nav-div">
        <Link to="/" className="links-text" id="link-viral">
            <div>Viral</div>
        </Link>
        {/*<Link to="/video" className="links-text" id="link-video">*/}
            {/*<div>Video</div>*/}
        {/*</Link>*/}
        {/*<a href="https://data.viral.net/engage" className="links-text" id="link-rates">*/}
            {/*<div>Data</div>*/}
         {/*</a>*/}
        <Link to="/talent" className="links-text" id="link-talent">
            <div>Talent</div>
        </Link>
    </div>
);

export default Nav


// WEBPACK FOOTER //
// ./src/components/nav/Nav.js